import type { NavigateTo } from '@core/app/scripts/services/navigate-to';
import { Broadcaster } from '@core/app/scripts/services/broadcaster';
import { DisplayMessage } from '@core/app/scripts/services/display-message';
import { Mask } from '@core/app/scripts/services/mask';
import { Withdrawal } from '@shared/app/scripts/services/withdrawal';

/*
 * Component responsible for /withdrawal route.
 *
 * A withdrawal is a type of sales transaction where cash is removed from the
 * cash drawer to pay for items such as postage, food, etc.  The opposite of a
 * withdrawal is a deposit where cash is added to the cash drawer
 */
angular
  .module('posApp')
  .directive(
    'withdrawal',
    (
      displayMessage: DisplayMessage,
      mask: Mask,
      navigateTo: NavigateTo,
      parser,
      pos,
      posReasons,
      sendWithdrawal,
      translate: ng.translate.ITranslateService,
      withdrawal: Withdrawal,
    ) => ({
      restrict: 'E',

      scope: true,

      template: require('./withdrawal.html').default,

      link: function ($scope, element, attrs) {
        const $translate = translate;

        $scope.pos = pos;
        $scope.posReasons = posReasons;

        $scope.processingRequest = false;

        $scope.withdrawelreason = posReasons.withdrawal[0];

        $scope.navigateToView = (view) => {
          navigateTo(view);
        };

        function resetForm() {
          if ($scope.withdrawalEntryForm) {
            $scope.withdrawalEntryForm.$setPristine();
          } else if ($scope.openDrawerEntryForm) {
            $scope.openDrawerEntryForm.$setPristine();
          }
          delete $scope.amount;
          mask.hide();
          $scope.processingRequest = false;
        }

        $scope.procWithdrawal = () => {
          // Set this flag in order to block the UI
          $scope.processingRequest = true;
          let amount;
          displayMessage.showLoading();

          try {
            // Remove comma and replace with decimal
            $scope.amount = $scope.amount.replace(',', '.');
            amount = parser.evaluate($scope.amount);
          } catch (err) {
            displayMessage.message($translate.instant('IncorrectEntry'));
            resetForm();
          }

          if (amount <= -99999999 || amount >= 99999999) {
            displayMessage.message(
              $translate.instant('Maximum Input Exceeded'),
            );
            resetForm();
            return;
          }

          // Amount must be greater or less than 0
          if (amount) {
            withdrawal.startNew().then((transaction) => {
              pos.setCashier(transaction, pos.config.selectedCashier);
              pos.setDate(transaction);

              transaction.withdrawelreason = $scope.withdrawelreason;

              /* Set the withdrawal amount to the amount entered by the user
               * A deposit is a negative withdrawal, but a positive cash entry because the user adds cash to the drawer
               * A withdrawal is positive, but a negative cash entry because the user takes cash out of the drawer
               */
              if (pos.config.cashDirection === 'posDeposit') {
                transaction.payments.cash = amount;
              } else {
                transaction.payments.cash = -amount;
              }

              sendWithdrawal(transaction);
            });
          } else {
            displayMessage.message($translate.instant('IncorrectEntry'));
            resetForm();
          }
        };

        $scope.cancelWithDrawal = () => {
          resetForm();
          navigateTo('pos.route#more');
        };

        $scope.cancelOpenDrawer = () => {
          $scope.openDrawerEntryForm.$setPristine();
          navigateTo('pos.route#more');
        };
      },
    }),
  );
